import {ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, inject, output, viewChild, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormControlOptions, Validators, ReactiveFormsModule} from '@angular/forms';
import {distinctUntilChanged, Subscription} from 'rxjs';
import {InsertOpenedService} from "../../../../services/ui/insert-opened.service";
import {ToggleButtonComponent} from '../../toggle-button/toggle-button.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
	selector: 'app-select-insert',
	templateUrl: './select-insert.component.html',
	styleUrl: '../multi-select.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ReactiveFormsModule, ToggleButtonComponent, TranslatePipe]
})
export class SelectInsertComponent implements OnInit, OnDestroy {
	private cdr = inject(ChangeDetectorRef);
	private insertOpenedService = inject(InsertOpenedService);

	@Input() titlePath = 'dropdown.defaultCreateFieldHeader';
	@Input() titlePathSearchNoResult = 'global.multiSelect.createFieldHeaderNoResult';
	@Input() saving = false;
	@Input() withToggle = false;
	@Input() toggleText = 'dropdown.defaultCreateFieldToggle';
	@Input() placeholder = 'global.writeHere';
	@Input() validators: Validators[] = [Validators.required, Validators.minLength(1)];


	@Input() searchTerm = '';
	@Input() noResults = false;
	@Input() hidden = false;


	readonly create = output<string>();
	readonly createWithToggle = output<{
    value: string;
    toggle: boolean;
}>();

	readonly searchElement = viewChild.required<ElementRef>('search');

	createForm: FormControl<string | null>;
	toggleFormControl: FormControl<boolean | null>;
	openForm = false;
	subscription: Subscription = new Subscription();

	ngOnInit(): void {
		this.createForm = new FormControl<string>('', this.validators as FormControlOptions);
		if (this.withToggle) {
			this.toggleFormControl = new FormControl<boolean>(true);
		}
		this.subscription.add(this.createForm.valueChanges
			.pipe(distinctUntilChanged())
			.subscribe(value => value?.trim()));
	}

	onCreate(): void {
		if (this.formValid) {
			if (this.withToggle) {
				this.createWithToggle.emit({value: this.createForm.value!, toggle: this.toggleFormControl.value!});
			} else {
				this.create.emit(this.createForm.value!);
			}
			this.createForm.reset('');
			this.openForm = false;
		}
	}

	onCreateWithSearchTerm(): void {
		if (this.searchTerm) {
			if (this.withToggle) {
				this.createWithToggle.emit({value: this.searchTerm, toggle: this.toggleFormControl?.value || true});
			} else {
				this.create.emit(this.searchTerm);
			}
		}
	}

	setFormOpened(): void {
		this.openForm = !this.openForm;
		this.insertOpenedService.sendInsertOpenState(this.openForm);
		if (this.openForm) {
			this.cdr.detectChanges();
			this.searchElement().nativeElement.focus();
		}
	}

	get formValid(): boolean {
		return this.createForm.valid && this.createForm.dirty;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
